// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"43fe3342","455":"6f4d2b47","977":"c70e4773"}[chunkId] + ".chunk.js";
};